export default {
  apcLocal: 0,
  apcInternational: 0,
};
